import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import RepProgressBar from '../../atoms/RepProgressBar';
import { COLORS } from '../../../plTheme';
import { _t_ } from '../../../utils/translation/translation';
import { _n_ } from '../../../utils/numerals/numerals';

interface RepComparisonSalesOutcomeProps {
  type: string;
  headingName: string;
  firstPersonValue?: number | null | undefined;
  secondPersonValue?: number | null | undefined;
  // totalSalesClosed?: number | null | undefined;
  maxValue?: number | null | undefined;
  minValue?: number | null | undefined;

  avgValue?: number | null | undefined;
  index: number;
}

const RepComparisonSalesOutcome: React.FC<RepComparisonSalesOutcomeProps> = ({
  type,
  headingName,
  firstPersonValue,
  secondPersonValue,
  maxValue,
  minValue,
  avgValue,
  index,
}: RepComparisonSalesOutcomeProps) => {
  let avg: any = secondPersonValue && avgValue && secondPersonValue - avgValue;
  // if (type === 'percentage' || type === 'winRatePercentage') {
  //   avg = avg?.toString() + '%';
  // }

  let percentage = 0,
    percentage1 = 0;
  if (firstPersonValue) {
    if (maxValue && maxValue != 0) {
      percentage = Math.round((firstPersonValue / maxValue) * 100);
      percentage1 = Math.round((secondPersonValue! / maxValue) * 100);
    }
  }
  const useStyles = makeStyles({
    root: {
      width: '90%',
      height: '48px',
      backgroundColor: COLORS.REPORTPAGE6BACKGROUNDCOLOR,
      border:
        index == 0 ? '1px solid #2E6FF2' : '1px solid rgba(215, 223, 233, 0.2)',
      // border: '1px solid rgba(215, 223, 233, 0.2)',
      position: 'relative',
      marginLeft: 50,
      marginRight: 50,
    },
    heading: {
      lineHeight: '20px',
      color: COLORS.REPCOMPARISONHEADINGCOLOR,
      marginLeft: -5,
      width: '172px',
      marginTop: 10,
      fontWeight: 400,
    },

    progressBarDiv: {
      width: '150px',
    },
    progressBarValue: {
      marginTop: '1px',
      marginLeft: percentage < 0 ? '0%' :percentage > 97 ? '92%' : `${percentage - 5}%`,
      marginBottom: '1px',
      width: 'fit-content',
    },
    progressBarValue1: {
      marginTop: '1px',
      marginLeft: percentage1 >= 97 ? '92%' : `${percentage1 - 5}%`,
      marginBottom: '1px',
      width: 'fit-content',
    },

    footerElement: {
      marginTop: '3px',
    },
    // errorDiv: {
    //   position: 'relative',
    //   top: '-15px',
    //   left: '460px',
    //   color: 'COLORS.PORTFOLIO',
    //   width: '25px',
    //   height: '25px',
    // },
  });

  const classes = useStyles();

  const formatData = (name: string, data: any) => {
    let formattedValue = 'NA';
    let value = +data;

    if (name.includes('$')) {
      // Format as currency
      if (value >= 1000000) {
        // For values greater than or equal to 1 million, divide by 1000 and format
        formattedValue = (value / 1000).toFixed(1); // Convert to thousands with 1 decimal
        formattedValue = Number(formattedValue).toLocaleString(); // Convert back to number and add commas
      } else if (value < 1000) {
        formattedValue = `${(value / 1000).toFixed(1)}`; // Show as 0.x if in hundreds
      } else {
        formattedValue = nFormatter(value, 1).replace('K', '');
        formattedValue = parseFloat(formattedValue).toLocaleString(); // Adds commas
      }
      formattedValue = formattedValue?.includes('.')
        ? formattedValue
        : `${formattedValue}.0`;
      // formattedValue = `${parseFloat(formattedValue).toFixed(1)}`; // Ensure 1 decimal place for all $
    } else if (name.includes('%')) {
      // Format as percentage with 1 decimal place always
      formattedValue = `${value.toFixed(1)}`;
    } else formattedValue = `${value}`;

    return formattedValue;
  };

  const firstPersonData =
    firstPersonValue && formatData(headingName, firstPersonValue);

  const secondPersonData =
    secondPersonValue && formatData(headingName, secondPersonValue);

  avg = avg && formatData(headingName, avg);
  avg = headingName.includes('%') ? `${avg}%` : avg;

  const persona = sessionStorage.getItem('persona');

  return (
    <Grid
      container
      direction="row"
      justify="space-around"
      className={classes.root}
    >
      {/* {barBackgroundColor === COLORS.AVATARS_RED_2 ? (
        <ErrorIcon className={classes.errorDiv} />
      ) : (
        ''
      )} */}
      <Grid item>
        <Typography variant="h5" className={classes.heading}>
          {_t_(
            `${persona === 'LEADER' ? `${headingName}*` : `${headingName}`}`,
          )}
        </Typography>
      </Grid>
      <Grid item style={{ margin: '2px 0 -2px 0' }}>
        <Grid container direction="column" justify="space-between">
          <Grid item className={classes.progressBarDiv}>
            <Typography
              variant="h6"
              className={classes.progressBarValue}
              align="right"
            >
              {type === 'percentage' || type === 'winRatePercentage'
                ? `${firstPersonValue ? firstPersonValue.toFixed(1) : 0}%`
                : type === 'amount' || type === 'dealSizeAmount'
                ? // ? firstPersonValue && Math.round(firstPersonValue / 1000)
                  firstPersonData
                : firstPersonValue}
            </Typography>
          </Grid>
          <Grid item>
            <RepProgressBar
              value={firstPersonValue}
              type={type}
              maxValue={maxValue}
              minValue={minValue}
              avgValue={(avgValue! / maxValue!) * 100}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ margin: '2px 0 -2px 0' }}>
        <Grid container direction="column" justify="space-between">
          <Grid item className={classes.progressBarDiv}>
            <Typography
              variant="h6"
              className={classes.progressBarValue1}
              align="right"
            >
              {type === 'percentage' || type === 'winRatePercentage'
                ? `${secondPersonValue ? secondPersonValue?.toFixed(1) : 0}%`
                : type === 'amount' || type === 'dealSizeAmount'
                ? // ? secondPersonValue && Math.round(secondPersonValue / 1000)
                  secondPersonData
                : secondPersonValue}
            </Typography>
          </Grid>
          <Grid item>
            <RepProgressBar
              value={secondPersonValue}
              type={type}
              maxValue={maxValue}
              minValue={minValue}
              avgValue={(avgValue! / maxValue!) * 100}
            />
          </Grid>
          <Grid item className={classes.footerElement}>
            <Typography variant="h6">
              {avg && avg.toString().includes('-')
                ? `${avg} avg`
                : `+ ${avg && avg.toString()} avg`}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RepComparisonSalesOutcome;

function nFormatter(num: any, digits: any) {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'K' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];
  const rx = /\$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item
    ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
    : '0';
}
